<app-button (onClick)="clickEvent()" [small]="true" style="width: 100%" [disabled]="searching">
    Search
    <span *ngIf="searching">
        &nbsp;
        <i class="fas fa-spinner fa-fw fa-pulse"></i>
    </span>
</app-button>